import { ErrorResponse, HttpMethod } from '@aibees/shared/definition';
import { useNotify } from '@aibees/shared/hooks';
import {
  useInsufficientCreditStore,
  useRateLimitReachedStore,
} from '@aibees/shared/store';
import { useMutation } from '@tanstack/react-query';
import { AxiosRequestConfig } from 'axios';
import baseFetcher from '../fetcher/base-fetcher';
import { MutationOptions } from '../types';
import { toErrorResponse } from '../utils';

export function useBaseMutation<
  Req = unknown,
  Res = never,
  Variables = Req,
  Key = unknown
>(
  config: AxiosRequestConfig<Req>,
  options?: Omit<MutationOptions<Res, Variables, Key>, 'mutationFn'>
) {
  const notify = useNotify();
  const { setIsError } = useInsufficientCreditStore();
  const { setIsError: setRateLimitReached } = useRateLimitReachedStore();

  return useMutation<Res, ErrorResponse, Variables, Key>(async (data) => {
    try {
      return await baseFetcher({
        method: HttpMethod.post,
        ...config,
        data,
      });
    } catch (error) {
      const err = toErrorResponse(error);
      if (!options?.doNotShowErrorNotification && err.cause.code !== 402)
        notify.error(err.message);
      if (err.cause.code === 402) {
        setIsError(true);
      }
      if (err.cause.code === 429) {
        setRateLimitReached(true);
      }
      return Promise.reject(err);
    }
  }, options);
}
